import axios from 'axios';

// Airtable requests go through the hosting nginx (/airtable/ location),
// which injects the API token server-side.
const baseURL =
  '/airtable/v0/appcUTSVuf734QvBw/tblU6bSB98J4U5xxX?returnFieldsByFieldId=true';
const testURL =
  '/airtable/v0/appUxS2CTelmO3fGg/tblCJa2iy7XnEihCH?returnFieldsByFieldId=true';

export async function fetchEvents(offset, testing = false) {
  const url = testing === 'true' ? testURL : baseURL;

  return new Promise((resolve, reject) => {
    var config = {
      method: 'get',
      url: offset ? `${url}&offset=${offset}` : url,
    };

    axios(config)
      .then(function(response) {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
